import { Language } from '@coolblue-development/constants';
import { convertDatePartsToObject, getLocale } from '../helpers.js';
/**
 * function: formatTime
 * Pattern: TimeFormat
 * Example: 05.00
 *
 * Variations in PHP
 * nl_NL: 'HH.mm'
 * fr_BE: "HH 'h' mm"
 * en_US: 'HH:mm'
 * de_DE: 'HH:mm'
 */
export function formatTime({ date = new Date(), language, subsidiary }) {
    const locale = getLocale(language, subsidiary);
    const timeFormat = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
    const parts = timeFormat.formatToParts(date);
    const { hour, minute } = convertDatePartsToObject(parts);
    if (language === Language.DUTCH) {
        return `${hour}.${minute}`;
    }
    else if (language === Language.FRENCH) {
        return `${hour} h ${minute}`;
    }
    return `${hour}:${minute}`;
}
//# sourceMappingURL=formatTime.js.map